/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import queryVariableTypes from './QueryVariableTypes';

export default {
    [queryVariableTypes.BYTE]: 'number',
    [queryVariableTypes.SHORT]: 'number',
    [queryVariableTypes.INTEGER]: 'number',
    [queryVariableTypes.BIG_INTEGER]: 'number',
    [queryVariableTypes.LONG]: 'number',
    [queryVariableTypes.DOUBLE]: 'number',
    [queryVariableTypes.DECIMAL]: 'number',
    [queryVariableTypes.FLOAT]: 'number',
    [queryVariableTypes.BIG_DECIMAL]: 'number',
    [queryVariableTypes.DATE]: queryVariableTypes.DATE,
    [queryVariableTypes.TIME]: queryVariableTypes.TIME,
    [queryVariableTypes.TIMESTAMP]: queryVariableTypes.TIMESTAMP,
    [queryVariableTypes.STRING]: queryVariableTypes.STRING,
    [queryVariableTypes.BOOLEAN]: queryVariableTypes.BOOLEAN,
}
